"use client";

import * as X from "@/ui";

import { HeroSection } from "./1.Hero";
import { RatingsSection } from "./2.Ratings";
import { CalculatorSection, MobileCalculatorModal } from "./3.Calculator";
import { WhyZapptaxSection } from "./4.WhyZapptax";
import { CustomerSupportSection } from "./5.CustomerSupport";
import { BestRatesSection } from "./6.BestRates";
import { TestimonialsSection } from "./7.Testimonials";
import { FeaturedFaqSection } from "./8.FeaturedFaq";
import { LearnMoreSection } from "./9.LearnMore";
import { useTravelerHomePage } from "@/providers/strapi/content/types/singleTypes/traveler-home-page";
import { useNewsLetterCard } from "@/providers/strapi/content/types/singleTypes/newsletter-card";


export function TravelerHomeClient(props: X.PageProps) {
  const [downloadModalOpen, setDownloadModalOpen] = X.useState(false);
  const [mobileCalculatorOpen, setMobileCalculatorOpen] = X.useState<boolean>(false);

  const blogCard = useTravelerHomePage('blogCard');
  const newsletterCard = useNewsLetterCard('card');
  const faqSection = useTravelerHomePage('faq');

  return (
    <>
      {/* <div className="h-20 bg-black text-white flex items-center justify-center">
        Bandeau en haut
      </div>

      <header className="sticky top-0 z-50 bg-blue-500 text-white h-16 flex items-center justify-center">
        Header sticky
      </header>

      <main className="h-[2000px] bg-gray-100 p-4">
        Contenu qui scroll
      </main> */}
      <X.MainLayout locale={props.locale} withHeroImage >
        <HeroSection locale={props.locale} onDownloadApp={() => setDownloadModalOpen(true)} />
        <RatingsSection locale={props.locale} />
        <CalculatorSection locale={props.locale} onOpenMobileCalculator={() => setMobileCalculatorOpen(true)} />
        <WhyZapptaxSection locale={props.locale} />
        <CustomerSupportSection locale={props.locale} onDownloadApp={() => setDownloadModalOpen(true)} />
        <BestRatesSection locale={props.locale} />
        <TestimonialsSection locale={props.locale} onDownloadApp={() => setDownloadModalOpen(true)} />
        <FeaturedFaqSection locale={props.locale} faqSection={faqSection} />
        <LearnMoreSection locale={props.locale} blogCard={blogCard} newsletterCard={newsletterCard} />
      </X.MainLayout>

      <X.DownloadModal
        locale={props.locale}
        isOpen={downloadModalOpen}
        onClose={() => setDownloadModalOpen(false)}
      />

      <MobileCalculatorModal
        locale={props.locale}
        isOpen={mobileCalculatorOpen}
        onClose={() => setMobileCalculatorOpen(false)}
      />
    </>
  );
}


